import setImageOptions from "app/media/helpers/setImageOptions";
import { UmbracoImage } from "app/media/models/media.interface";
import { SiteSetting } from "../models/settings.model";
import { PAGE_TYPE } from "../pages/page.types";

/* Getting meta data for head from page content */
interface PageMeta {
  language: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  metaCanonical: string;
  robots: string;
  socialTitle: string;
  socialDescription: string;
  socialImage: string;
  url: string;
}

const getImageUrl = (umbracoImage?: UmbracoImage): string | undefined => {
  if (umbracoImage) {
    const crop = umbracoImage.umbracoFile.crops?.find(
      (crop) => crop.alias === "Square (1:1)"
    );
    return setImageOptions(
      umbracoImage.umbracoFile.src,
      1280,
      umbracoImage.umbracoExtension,
      crop,
      umbracoImage.umbracoFile.focalPoint,
      1
    );
  } else {
    return undefined;
  }
};

export default (page: PAGE_TYPE, settings: SiteSetting): PageMeta => {
  let language = "";
  let metaTitle = "";
  let metaDescription = "";
  let metaKeywords = "";
  let metaCanonical = "";
  let robots = "";
  let socialTitle = "";
  let socialDescription = "";
  let socialImage = "";
  let url = "";

  if (page) {
    switch (page._contentType) {
      case "homePage":
      case "contentPage":
      case "eventPage":
      case "newsPage": {
        language = page._culture || "da-dk";
        metaTitle = page.metaTitle || page._name || "WLS";
        metaDescription = page.metaDescription || "";
        metaKeywords = page.metaKeywords || "";
        metaCanonical = page.canonical || page._url || "";
        robots = `${page.metaAllowIndexing ? "index" : "noindex"},${
          page.metaAllowFollowing ? "follow" : "nofollow"
        }`;
        socialTitle =
          page.socialTitle ||
          page.metaTitle ||
          settings?.fallbackSocialTitle ||
          page._name ||
          "WLS";
        socialDescription =
          page.socialDescription ||
          page.metaDescription ||
          settings?.fallbackSocialDescription ||
          "";
        socialImage =
          getImageUrl(page.socialImage) ||
          getImageUrl(settings?.fallbackSocialImage) ||
          "";
        url =
          page._url || `${window.location.origin}${window.location.pathname}`;
        break;
      }
    }
  }

  // TODO: Make a prettier return type
  return {
    language: language,
    metaTitle: metaTitle,
    metaDescription: metaDescription,
    metaKeywords: metaKeywords,
    metaCanonical: metaCanonical,
    robots: robots,
    socialTitle: socialTitle,
    socialDescription: socialDescription,
    socialImage: socialImage,
    url: url,
  };
};
